import React from 'react';
import { Textarea as UIBricksTextarea } from '@makemydeal/ui-bricks/dist/cox';

const TextArea: React.FC<React.ComponentProps<typeof UIBricksTextarea>> = React.forwardRef((props, ref) => {
    return <UIBricksTextarea ref={ref} {...props} />;
});

TextArea.displayName = 'TextArea';

export default TextArea;
